"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hideSaveDiscardButtons(currentSubcategory) {
    return currentSubcategory.options.reduce(function (state, option) {
        return state &&
            !!option.fullOptionFormSettings.hideSaveDiscard &&
            option.fullOptionFormSettings.hideSaveDiscard();
    }, true);
}
exports.default = hideSaveDiscardButtons;
//# sourceMappingURL=hideSaveDiscardButtons.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/utils/hideSaveDiscardButtons.js
// module id = 1837
// module chunks = 2 39 105 108